enum HeaderKind {
  SESSION = 'sessions',
  SIMPLE = 'simple',
}

export default HeaderKind;
